import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import './Button.css'

const Button = forwardRef(function Button(
  {
    variant,
    active = false,
    className,
    startIcon,
    endIcon,
    children,
    type = 'button',
    disabled = false,
    ...rest
  },
  ref,
) {
  const variantClass = (() => {
    switch (variant) {
      case 'secondary':
        return 'button__secondary'
      case 'tertiary':
        return 'button__tertiary'
      default:
        return 'button__primary'
    }
  })()

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={clsx(
        'button__base',
        'text-caps',
        variantClass,
        { button__active: active },
        className,
      )}
      {...rest}
    >
      {startIcon && (
        <span className="button__icon button__icon--start">{startIcon}</span>
      )}
      {children && <p className="button__label">{children}</p>}
      {endIcon && (
        <span className="button__icon button__icon--end">{endIcon}</span>
      )}
    </button>
  )
})

Button.displayName = 'Button'

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  active: PropTypes.bool,
  className: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  children: PropTypes.node,
  type: PropTypes.string,
  disabled: PropTypes.bool,
}

export default Button
